import ClassificationAction from '../actions/classification';

const initialState = {
    lodgingPreference: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
    case ClassificationAction.SET_LODGING_PREFERENCE:
        return { ...state, lodgingPreference: action.lodgingPreference };
    default:
        return state;
    }
};
